import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { renamedCoachPath } from "~/lib/shared/utils/username";

// Coaches who changed their public username after the old profile URL had
// already earned backlinks. 301 the old handle to the new one, keeping the
// rest of the path and the query, so the link equity follows the coach and
// links such as `/old/wheel-of-life` or `/old/book` still land on that page.
const RENAMED_COACH_USERNAMES: Record<string, string> = {
  madhuchandarsekaran: "madhuc",
};

export const Route = createFileRoute("/$username")({
  beforeLoad: ({ params, location }) => {
    const renamedTo = RENAMED_COACH_USERNAMES[params.username];
    if (renamedTo) {
      throw redirect({
        href: renamedCoachPath(location.href, params.username, renamedTo),
        statusCode: 301,
      });
    }
  },
  component: CoachPublicLayout,
});

// Pass-through boundary for the `/$username` segment. Site chrome lives in the
// child layouts (profile/book/contact get the full header + footer; offer
// pages get their own lighter chrome) so that offer landing pages can opt out
// of the marketplace nav.
function CoachPublicLayout() {
  return <Outlet />;
}
